export default function Logo() {
    return <h1>🏰 Da Nang - Hue - Hoi An 🚞</h1>
}